var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "modal", staticClass: "modal fade" }, [
    _c("div", { staticClass: "modal-dialog" }, [
      _c("div", { staticClass: "modal-content" }, [
        _c("div", { staticClass: "modal-body" }, [
          _c(
            "div",
            {
              ref: "target",
              staticClass:
                "dropzone d-flex justify-content-center align-items-center text-center",
            },
            [
              _c("div", { staticClass: "dz-message" }, [
                _vm._v(
                  "\n                        Drag and drop your logo here. Please upload transparent PNG file if available.\n                    "
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }